import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { Globals } from 'src/app/globals';
import { KycMarutiJourneyService } from '../kyc-maruti-journey/kyc-maruti-journey.service';
import { KycSearchRequest } from '../kyc-maruti-journey/kyc-maruti-journey-model';
import { KycSearchResponse } from '../kyc-hyperverge/kyc-hyperverge.model';
import { Observable, Subscription, interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'manualkyc-maruti-documents',
  templateUrl: './manualkyc-documents.component.html',
  styleUrls: ['./manualkyc-documents.component.css']
})
export class ManualkycDocumentsComponent implements OnInit {

  errMsg: string = "";
  backURL: string = "";
  isShowFileMandatory: boolean = false;
  isShowBackFileMandatory: boolean = false;
  fileErrMsg: string = "";
  backFileErrMsg: string = "";
  @ViewChild('fileData') myInputVariable: ElementRef;
  @ViewChild("maruthiKycDcoumentForm") maruthiKycDcoumentForm: NgForm;
  isLoading: boolean = false;
  public showValidationMsgs: boolean;
  private uploadedFile: File;
  private backUploadedFile: File;
  isKycSuccess: boolean = false;
  isKycFailed: boolean = false;
  kycRequest: KycSearchRequest = new KycSearchRequest();
  kycResponse: KycSearchResponse = new KycSearchResponse();
  identifierOrg: string;
  identifier: string;
  linkDetails: any;
  showPartnerportal: boolean = false;
  diff: number;
  future: Date;
  stopCountdown: boolean = false;
  subscription: Subscription;
  message: string;
  $counter: Observable<number>;
  dateOfBirthDoi: any;

  constructor(private route: ActivatedRoute, public router: Router, public globals: Globals, public datePipe: DatePipe, public kycMarutiJourneyService: KycMarutiJourneyService) {
    this.kycRequest = new KycSearchRequest();
    this.kycResponse = new KycSearchResponse();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(
      (params: Params) => {
        if (params['identifier']) {
          this.identifierOrg = params['identifier'];
          this.identifier = atob(params['identifier']);
        }
      }
    );
    if (this.identifier) {
      this.linkDetails = JSON.parse(this.identifier);
      this.kycRequest.uniqueId = this.linkDetails.uniqueId;
      this.kycRequest.customerType = this.returnCustomerType(this.linkDetails.customerType);
      this.kycRequest.appName = this.linkDetails.appName;
      this.kycRequest.returnURL = this.linkDetails.returnUrl;
      this.kycRequest.kycReferenceNo = this.linkDetails.kycReferenceNo;
      this.kycRequest.customerName = this.linkDetails.customerName;
    }
  }

  returnCustomerType(custType) {
    let customerType: string = "";
    if(custType == 'C' || custType == 'Corporate' || custType == 'CorporateCustomer') {
      customerType = "Corporate";
    } else if(custType == 'I' || custType == 'Individual' || custType == 'IndividualCustomer' ) {
      customerType = "Individual";
    } else {
      customerType = custType;
    }
    return customerType;
  }

  Submit(maruthiKycDcoumentForm: NgForm, isValid) {
    if (!isValid) {
      this.showValidationMsgs = true;
      this.validateAllFields(this.maruthiKycDcoumentForm.form);
      if (!this.uploadedFile && !this.backUploadedFile && this.kycRequest.searchType != 'Pan' && this.kycRequest.searchType != 'GSTIN' && this.kycRequest.customerType == 'Individual') {
        this.isShowFileMandatory = true;
        this.isShowBackFileMandatory = true;
        this.fileErrMsg = "Please upload jpg,pdf,png format file";
        this.backFileErrMsg = "Please upload jpg,pdf,png format file"
      }
    } else if (this.kycRequest.searchType != 'Pan' && this.kycRequest.searchType != 'GSTIN' && this.kycRequest.customerType == 'Individual' && ((this.backUploadedFile == null || this.backUploadedFile == undefined) || (this.uploadedFile == null || this.uploadedFile == undefined))) {
      if (this.backUploadedFile == null || this.backUploadedFile == undefined) {
        this.isShowBackFileMandatory = true;
        this.backFileErrMsg = "Please upload jpg,pdf,png format file";
      } if (this.uploadedFile == null || this.uploadedFile == undefined) {
        this.isShowFileMandatory = true;
        this.fileErrMsg = "Please upload jpg,pdf,png format file";
      }
    } else {
      this.clearData();
      if(this.kycRequest.uniqueId && this.kycRequest.uniqueId.substring(0,3).startsWith('KY3')){
        this.showPartnerportal = true;
      } else {
        this.showPartnerportal = false;
      }
      if(this.kycRequest.searchType == 'Pan' || this.kycRequest.searchType == 'GSTIN') {
        this.serviceCallToSearchPAN();
      } else {
        this.serviceCallToUpload();
      }
    }
  }

  serviceCallToSearchPAN() {
    this.isLoading = true;
    this.kycMarutiJourneyService.searchDownloadDefaultKYCDetails(this.kycRequest).subscribe((data: any) => {
      this.isLoading = false;
      this.kycResponse = JSON.parse(JSON.stringify(data));
      if(this.kycResponse && this.kycResponse.kycStatus) {
        this.isKycSuccess = true;
        this.isKycFailed = false;
      } else {
        this.isKycSuccess = false;
        this.isKycFailed = true;
      }
      if(this.isKycSuccess) {
        this.message = "5s";
        this.stopCountdown = false;
        this.startCountdown();
      }
    })
  }

  serviceCallToUpload() {
    this.isLoading = true;
    this.kycMarutiJourneyService.uploadKYCDocs(this.kycRequest).subscribe(result => {
      this.isLoading = false;
      this.kycResponse = JSON.parse(JSON.stringify(result));
      if (this.kycResponse && this.kycResponse.kycStatus) {
        this.isKycSuccess = true;
        this.isKycFailed = false;
      } else {
        this.isKycSuccess = false;
        this.isKycFailed = true;
      }
      if(this.isKycSuccess) {
        this.message = "5s";
        this.stopCountdown = false;
        this.startCountdown();
      }
    });
  }

  onUploadDoc(event) {
    this.isShowFileMandatory = false;
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      if (file && file.name && (file.name.toLowerCase().endsWith('jpeg') || file.name.toLowerCase().endsWith('jpg') || file.name.toLowerCase().endsWith('png') || file.name.toLowerCase().endsWith('pdf'))) {
        this.uploadedFile = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          let dataUrl = reader.result;
          let base64 = dataUrl.toString().split(",")[1];
          if (base64 && base64.length > 0) {
            this.kycRequest.fileFront = base64;
            this.kycRequest.fileNameFront = file.name;
            this.kycRequest.fileTypeFront = file.name.split(".")[1];
          };
        }
      } else {
        this.isShowFileMandatory = true;
        this.fileErrMsg = "Please upload jpg,pdf,png format file";
        this.uploadedFile = null;
        this.myInputVariable.nativeElement.value = "";
        return;
      }
    } else {
      this.uploadedFile = null;
      this.isShowFileMandatory = true;
      this.fileErrMsg = "Please Upload the file";
      this.myInputVariable.nativeElement.value = "";
      return;
    }
  }
  onUploadDoc1(event) {
    this.isShowBackFileMandatory = false;
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      if (file && file.name && (file.name.toLowerCase().endsWith('jpeg') || file.name.toLowerCase().endsWith('jpg') || file.name.toLowerCase().endsWith('png') || file.name.toLowerCase().endsWith('pdf'))) {
        this.backUploadedFile = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          let dataUrl = reader.result;
          let base64 = dataUrl.toString().split(",")[1];
          if (base64 && base64.length > 0) {
            this.kycRequest.fileBack = base64;
            this.kycRequest.fileNameBack = file.name;
            this.kycRequest.fileTypeBack = file.name.split(".")[1];
          };
        }
      } else {
        this.isShowBackFileMandatory = true;
        this.backFileErrMsg = "Please upload jpg,pdf,png format file";
        this.backUploadedFile = null;
        this.myInputVariable.nativeElement.value = "";
        return;
      }
    } else {
      this.backUploadedFile = null;
      this.isShowBackFileMandatory = true;
      this.backFileErrMsg = "Please Upload the file"
      this.myInputVariable.nativeElement.value = "";
      return;
    }
  }

  clearData() {
    this.fileErrMsg = "";
    this.backFileErrMsg = "";
    this.backUploadedFile = null;
    this.uploadedFile = null;
  }

  clearDataAfterSubmit() {
    this.clearData();
    this.showValidationMsgs = false;
    this.myInputVariable.nativeElement.value = "";
    this.kycRequest.fileFront = null;
    this.kycRequest.fileBack = null;
    this.kycRequest.fileNameFront = "";
    this.kycRequest.fileNameBack = "";
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  backToverificationPage() {
    this.router.navigate(['/kyc-maruti'], { queryParams: { 'identifier': this.identifierOrg } });
  }

  resetFields(value) {
    this.showValidationMsgs = false;
    if(this.myInputVariable && this.myInputVariable.nativeElement) {
      this.myInputVariable.nativeElement.value = "";
    }
    this.kycRequest.panNumber = "";
    this.kycRequest.dob_doi = "";
    this.kycRequest.gstin = "";
    this.dateOfBirthDoi = "";
  }

  public parseDateFormat(value): void {
    if (value) {
      let formattedDate: string = this.datePipe.transform(value, 'dd/MM/yyyy');
      this.kycRequest.dob_doi = formattedDate;
      console.log(formattedDate);
    }
  }

  backToPartnerPortal() {
    window.location.href = this.kycResponse.returnURL;
  }

  startCountdown() {
    var d1 = new Date(),
      d2 = new Date(d1);
    d2.setSeconds(d1.getSeconds() + 12);
    this.future = d2;
    //console.log(this.future.getTime()+"***"+new Date().getTime())
    if (this.stopCountdown == false) {
      this.$counter = interval(1000).pipe(
        map((x) => {
          if (this.stopCountdown == false) {
            this.diff = Math.floor((this.future.getTime() - new Date().getTime()) / 1000);
          }
          //console.log(this.diff);
          //console.log(this.diff>0);
          if (this.diff > 0) {
            this.stopCountdown = false;
            return x;
          }
          else {
            this.stopCountdown = true;
            this.subscription.unsubscribe();
            if(this.kycResponse.uniqueId && this.kycResponse.uniqueId.substring(0,3).startsWith('KY3') && this.isKycSuccess) {
              this.isLoading = true;
              window.location.href = this.kycResponse.returnURL;
            }
          }

        }));
      if (this.stopCountdown == false) {
        this.subscription = this.$counter
          .subscribe((x) => this.message = this.dhms(this.diff));
      }
    }
  }

  dhms(t) {
    let days, hours, minutes, seconds;
    seconds = t;
    if (this.stopCountdown == false) {
      return [
        seconds + 's'
      ].join(' ');
    }
  }
}